import { CMSRender } from '@/components/cms-render';
import { processSQSearch } from '@/utils/loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/mobilephone/coverage')({
  loader: ({ context }) => {
    const { queryClient } = context;
    processSQSearch(queryClient);
  },
  component: () => <CMSRender />,
});
